module.exports = __webpack_public_path__ + "media/images/footer-7b213c7071cd36178d392d4ac128284c.svg";